// extracted by mini-css-extract-plugin
export default {"mainContainer":"mainContainer___lf6ZJ","searchPaper":"searchPaper___iILPa","searchContainer":"searchContainer___TJcry"};